import type { Dictionnaire } from '../type';

export const temps: Dictionnaire['temps'] = {
  ilYa: {
    instant: 'just now',
    minutes: (n: number) => `${n} min ago`,
    heures: (n: number) => `${n} h ago`,
    jours: (n: number) => `${n} d ago`,
    semaines: (n: number) => `${n} wk ago`,
    mois: (n: number) => `${n} mo ago`,
    ans: (n: number) => `${n} yr${n > 1 ? 's' : ''} ago`,
  },
  hier: 'yesterday',
  Hier: 'Yesterday',
  aujourdhui: 'Today',
  heure: {
    pleine: (h: number) => `${String(h).padStart(2, '0')}:00`,
    avecMinutes: (h: number, minutes: string) => `${String(h).padStart(2, '0')}:${minutes}`,
  },
  masqueDate: 'DD / MM / YYYY',
  aujourdhuiMin: 'today',
};
